<div class="body" *ngIf="showContent">
    <div class="login-container text-center">
        <div class="flex" style="justify-content: center">
            <mat-card
                style="width: 500px"
                class="login-container-background mat-mdc-card-outlined">
                <mat-card-content>
                    <div class="logo mb-3"></div>

                    <!-- Display error message if present -->
                    <div *ngIf="errorMessage" class="alert alert-danger mb-3" role="alert" style="text-align: left; padding: 12px; border-radius: 4px; background-color: #f8d7da; border: 1px solid #f5c6cb; color: #721c24;">
                        <strong>Error:</strong> {{ errorMessage }}
                    </div>

                    <div style="padding-bottom: 1.75rem">
                        <mrs-btn-primary
                            buttonLabel="Sign In"
                            buttonId="signInButton"
                            (onClick)="signIn()">
                        </mrs-btn-primary>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
